import { createSlice, PayloadAction,createAsyncThunk} from "@reduxjs/toolkit";
import { RootState } from "../store";
import apiClient from "../api/client";
import { config } from "process";



// Login api request

// interface reqData {
//     username:string,
//     password:string
// }



export const loginUser = createAsyncThunk('user/login', async (reqData: string, { rejectWithValue }) => {
    try {
        const response = await apiClient.post('user/login', reqData);
        return response.data
    }
    catch (err) {
    let error:any = err // cast the error for access
    if (!error.response.data) {
      throw err
    }
    // We got validation errors, let's return those so we can reference in our component and set form errors
    return rejectWithValue(error.response.data.message)
    }
});



export const signupUser = createAsyncThunk('user/signup', async (reqData: string, { rejectWithValue }) => {
    try {
        
        const response = await apiClient.post('user/signup', reqData, 
        {
            headers: {
            'Content-Type': 'application/json',
          }
        }
          );
        return response.data
    }
    catch (err) {
    let error:any = err // cast the error for access
    if (!error.response.data) {
      throw err
    }
    // We got validation errors, let's return those so we can reference in our component and set form errors
    return rejectWithValue(error.response.data.message)
    }
});


export const logoutUser = createAsyncThunk('user/logout', async (reqData: string, { rejectWithValue }) => {
    try {
        
        const response = await apiClient.post('user/logout', reqData);
        return response.data
    }
    catch (err) {
    let error:any = err // cast the error for access
    if (!error.response.data) {
      throw err
    }
    // We got validation errors, let's return those so we can reference in our component and set form errors
    return rejectWithValue(error.response.data.message)
    }
});

export const requestNewPassword = createAsyncThunk('users/resetpassword', async (reqData: string, { rejectWithValue }) => {
    try {
        const response = await apiClient.post('users/resetpassword', reqData);
        return response.data
    }
    catch (err) {
        let error:any = err // cast the error for access
        if (!error.response.data) {
          throw err
        }
        // We got validation errors, let's return those so we can reference in our component and set form errors
        return rejectWithValue(error.response.data.message)
        }
});

export const requestResetPassword = createAsyncThunk('users/resetpassword?token=', async (reqToken: string, { rejectWithValue }) => {
    try {
        let baseURL = 'users/resetpassword?token=';
        let url = baseURL + reqToken;
        const response = await apiClient.get(url);
        return response.data
    }
    catch (err) {
        let error:any = err // cast the error for access
        if (!error.response.data) {
          throw err
        }
        // We got validation errors, let's return those so we can reference in our component and set form errors
        return rejectWithValue(error.response.data.message)
        }
});

interface UserState {
    username : string,
    loggedIn : boolean,
    email : string, 
    error: any,
    status: string,
    newPasswordError: any,
}

// Below we set up our initial state. Feel free to add more if you'd like more information about users to be shown, for instance a biography.
const initialState: UserState = {
    username : '',
    loggedIn : false,
    email : "",
    status : 'idle',
    error : '',
    newPasswordError:''
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        login: (state) => {
            state.loggedIn = true
        },
        logout: (state) => {
            state.loggedIn = false; 
            localStorage.removeItem('access_token')
            state.username = "";
            state.email = "";
        },

        changeCurrentUsername: (state, action:PayloadAction<string>) => {
            state.username = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(loginUser.pending, (state)=>{
            state.status = 'loggin in';
        })
        builder.addCase(loginUser.fulfilled, (state, action) => {
            state.status = '';
            state.loggedIn = true;
            localStorage.setItem('access_token', action.payload.access_token);
            state.error = action.payload.message;
        })
        builder.addCase(loginUser.rejected, (state, action) => {
            if (action.payload) {
                state.error = action.payload;
              } else {
                state.error = action.error.message;
                state.status = '';
                state.loggedIn = false;
                state.username = '';
                state.email = "";
              }
        })
    
        builder.addCase(signupUser.pending, (state)=>{
            state.status = '';
            state.error = "";
        })
        builder.addCase(signupUser.fulfilled, (state, action) => {
            state.status = action.payload.message;
            state.loggedIn = false;
            // localStorage.setItem('token', action.payload.token);
            state.error = ""
        })
        builder.addCase(signupUser.rejected, (state, action) => {
            state.status = '';
            state.loggedIn = false;
            if (action.payload) {
                state.error = action.payload;
              } else {
                state.error = action.error.message;
              }
        })

        builder.addCase(logoutUser.pending, (state)=>{
            state.status = 'loggin out';
        })
        builder.addCase(logoutUser.fulfilled, (state, action) => {
            state.status = '';
            state.loggedIn = false;
            state.username = "";
            state.email = "";
            // localStorage.setItem('token', action.payload.token);
            state.error = '';
            localStorage.removeItem("access_token")

        })
        builder.addCase(logoutUser.rejected, (state,action) => {
            state.status = '';
            state.loggedIn = false;
            localStorage.removeItem("access_token")
            if (action.payload) {
                state.error = action.payload;
              } else {
                state.error = action.error.message;
              }
        })

        builder.addCase(requestNewPassword.pending, (state)=>{
            state.status = "request pending"
            state.newPasswordError ='';
            
        })
        builder.addCase(requestNewPassword.fulfilled, (state, action) => {
            state.status = '';
            state.loggedIn = false;
            state.username = "";
            state.email = "";
            state.status = action.payload.message; 
            // localStorage.setItem('token', action.payload.token);
            state.error = action.payload.message;
            state.newPasswordError ='';

        })
        builder.addCase(requestNewPassword.rejected, (state, action) => {
            state.status = '';
            state.loggedIn = false;
            if (action.payload) {
                state.error = action.payload;
              } else {
                state.error = action.error.message;
              }
            state.newPasswordError ='';
        })
        builder.addCase(requestResetPassword.pending, (state)=>{
            state.newPasswordError ='';
            state.error = '';
            
        })
        builder.addCase(requestResetPassword.fulfilled, (state, action) => {
            state.newPasswordError = action.payload.message;
        }
        )
        builder.addCase(requestResetPassword.rejected, (state, action) => {
            if (action.payload) {
                state.newPasswordError = action.payload;
              } else {
                state.newPasswordError = action.error.message;
              }
        })
    }
})

export const {login, changeCurrentUsername, logout} = userSlice.actions

export const selectUser = (state:RootState) => state.user;

export default userSlice.reducer
